<template>
  <!-- Main Sidebar Container -->
  <aside class="main-sidebar sidebar-dark-primary elevation-4">
    <!-- Brand Logo -->
    <a
      href="#"
      class="brand-link">
      <img
        src="@/assets/logo.png"
        alt="Logo"
        class="brand-image img-circle elevation-3"
        style="opacity: .8">
      <span class="brand-text font-weight-light">
        E-Class Admin
      </span>
    </a>
    <!-- Sidebar -->
    <div class="sidebar">
      <!-- Sidebar Menu -->
      <nav class="mt-2">
        <ul
          class="nav nav-pills nav-sidebar flex-column"
          data-widget="treeview"
          role="menu"
          data-accordion="false">
          <!-- Add icons to the links using the .nav-icon class
               with font-awesome or any other icon font library -->
          <li class="nav-item has-treeview menu-open">
            <a
              href="#"
              class="nav-link">
              <i class="nav-icon fa fa-circle"/>
              <p>Master
                <i class="right fa fa-angle-left"/>
              </p>
            </a>
            <ul class="nav nav-treeview">
              <li class="nav-item">
                <router-link
                  to="/M0001User"
                  class="nav-link inactive"
                >
                  <i class="fa fa-circle-o nav-icon"/>
                  <p>User</p>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/M0101Branch"
                  class="nav-link inactive"
                >
                  <i class="fa fa-circle-o nav-icon"/>
                  <p>School</p>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/M0201Chapters"
                  class="nav-link inactive"
                >
                  <i class="fa fa-circle-o nav-icon"/>
                  <p>Chapters</p>
                </router-link>
              </li>
              <!--
              <li class="nav-item">
                <router-link
                  to="/M0201Chapter"
                  class="nav-link inactive"
                >
                  <i class="fa fa-circle-o nav-icon"/>
                  <p>Chapter</p>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/M0202Title"
                  class="nav-link inactive"
                >
                  <i class="fa fa-circle-o nav-icon"/>
                  <p>Title</p>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/M0203Question"
                  class="nav-link inactive"
                >
                  <i class="fa fa-circle-o nav-icon"/>
                  <p>question with text and img, answer by text</p>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/M0204Answer"
                  class="nav-link inactive"
                >
                  <i class="fa fa-circle-o nav-icon"/>
                  <p>Answer with text and img, answer by text</p>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/M0301CommissionSetting"
                  class="nav-link inactive"
                >
                  <i class="fa fa-circle-o nav-icon"/>
                  <p>Commission Setting</p>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/M0302CommissionRecord"
                  class="nav-link inactive"
                >
                  <i class="fa fa-circle-o nav-icon"/>
                  <p>Commission Record</p>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/M0303CommissionPayment"
                  class="nav-link inactive"
                >
                  <i class="fa fa-circle-o nav-icon"/>
                  <p>Commission Payment</p>
                </router-link>
              </li> -->
              <li class="nav-item">
                <router-link
                  to="/M0401Class"
                  class="nav-link inactive"
                >
                  <i class="fa fa-circle-o nav-icon"/>
                  <p>Class</p>
                </router-link>
              </li>
              <!--<li class="nav-item">
                <router-link
                  to="/M0402ClassInstructor"
                  class="nav-link inactive"
                >
                  <i class="fa fa-circle-o nav-icon"/>
                  <p>Class Instructor</p>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/M0403ClassStudent"
                  class="nav-link inactive"
                >
                  <i class="fa fa-circle-o nav-icon"/>
                  <p>Class Student</p>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/M0404ClassUnit"
                  class="nav-link inactive"
                >
                  <i class="fa fa-circle-o nav-icon"/>
                  <p>Class Unit</p>
                </router-link>
              </li>-->
              <!-- <li class="nav-item">
                <router-link
                  to="/M0405ClassUnitAttendant"
                  class="nav-link inactive"
                >
                  <i class="fa fa-circle-o nav-icon"/>
                  <p>Class Unit Attendant</p>
                </router-link>
              </li> -->
              <li class="nav-item">
                <router-link
                  to="/M0501Course"
                  class="nav-link inactive"
                >
                  <i class="fa fa-circle-o nav-icon"/>
                  <p>Course</p>
                </router-link>
              </li>
              <!--li class="nav-item">
                <router-link
                  to="/M0502CourseLevel"
                  class="nav-link inactive"
                >
                  <i class="fa fa-circle-o nav-icon"/>
                  <p>Course Level</p>
                </router-link>
              </li>-->
              <li class="nav-item">
                <router-link
                  to="/M0503MaterialLicense"
                  class="nav-link inactive"
                >
                  <i class="fa fa-circle-o nav-icon"/>
                  <p>Material License</p>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/M0601Instructor"
                  class="nav-link inactive"
                >
                  <i class="fa fa-circle-o nav-icon"/>
                  <p>Instructor</p>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/M0602Student"
                  class="nav-link inactive"
                >
                  <i class="fa fa-circle-o nav-icon"/>
                  <p>Student</p>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/S0101DataImport"
                  class="nav-link inactive"
                >
                  <i class="fa fa-circle-o nav-icon"/>
                  <p>Data Import</p>
                </router-link>
              </li>
            </ul>
          </li>
          <!-- /.sidebar-menu -->
    </ul></nav></div>
  <!-- /.sidebar -->
  </aside>
</template>
<script>
export default {
  name: 'Sidebar',
  data: function () {
    return {
    }
  }

}
</script>



// WEBPACK FOOTER //
// src/components/organisms/OrSidebar.vue